import React, { PureComponent } from 'react';

export class BodyWrapper extends PureComponent {
  componentDidMount() {
    const ht = document.getElementsByTagName('html')[0];
    ht.style.minWidth = 'unset';
    document.body.style.minWidth = 'unset';
  }

  componentWillUnmount() {
    const ht = document.getElementsByTagName('html')[0];
    ht.style.minWidth = '1200px';
    document.body.style.minWidth = '1200px';
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default BodyWrapper;
